declare namespace $ {

	export class $mol_icon_flag_checkered extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=checkered.view.tree.d.ts.map